module.exports = __webpack_public_path__ + "linea-basic-10.e4de528c00da0c081906.eot";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/linea-icons/fonts/linea-basic-10.eot
// module id = ../../../../../src/scss/icons/linea-icons/fonts/linea-basic-10.eot
// module chunks = styles